import {
	SET_SETTINGS,
	ADD_SETTING,
	UPDATE_SETTING,
	REMOVE_SETTING
} from "../../actions/DashboardDesigner/actionContants";

const settings = (state = {}, action) => {
	switch (action.type) {
		case SET_SETTINGS:
			return action.data;
		case UPDATE_SETTING:
			return { ...state, [action.setting]: action.value };
		default:
			return state;
	}
};

export default settings;
